// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"az_nr","breadcrumbItem":"az_or","breadcrumbSeparator":"az_pr"};